import { create } from "zustand";
import { GetBootstrapConfigReply } from "@marketplace/myplace-connect/myplace_pb";
import type { ExperimentTheme } from "hooks/useExperiment";

type State = {
  bootstrap?: GetBootstrapConfigReply;
  experimentTheme?: ExperimentTheme;
};

type Action = {
  getBootstrap: () => Promise<GetBootstrapConfigReply>;
  setExperimentTheme: (theme: ExperimentTheme) => void;
};

export const useMyStore = create<State & Action>((set) => ({
  setExperimentTheme: (theme) => set({ experimentTheme: theme }),
  getBootstrap: async () => {
    const res = await fetch(
      `https://${process.env.REACT_APP_BOOTSTRAP_DOMAIN}/api/moose/v1/bootstrapconfig`,
      {
        headers: {
          "x-tenant-id": process.env.REACT_APP_NAU_TENANT_ID || "",
          "x-referer": window.location.hostname,
        },
      },
    );
    const jsonRes = await res.json();
    const bootstrap = GetBootstrapConfigReply.fromJson(jsonRes, {
      ignoreUnknownFields: true,
    });

    set({ bootstrap });

    return bootstrap;
  },
}));
